import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ExitingPersistence, FadeIn } from '@atlaskit/motion';
import AkSpinner from '@atlaskit/spinner';
import React from 'react';
import { ContentWrapper, Mask, SpinnerContainer } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getSpinnerTestId = testId => {
  if (testId !== null && testId !== void 0 && testId.length) return "".concat(testId, "--spinner");
};
const SPINNER_MASK_DEFAULT_SIZE = 'large';
const SPINNER_MASK_DEFAULT_MIN_HEIGHT = 100;
const SpinnerMask = props => {
  const {
    active,
    appearance,
    children,
    className,
    delay,
    minHeight = SPINNER_MASK_DEFAULT_MIN_HEIGHT,
    size = SPINNER_MASK_DEFAULT_SIZE,
    testId,
    interactionName
  } = props;
  return /*#__PURE__*/_jsxs(Mask, {
    minHeight: minHeight,
    "data-testid": testId,
    className: className,
    children: [/*#__PURE__*/_jsx(ExitingPersistence, {
      appear: true,
      children: active && /*#__PURE__*/_jsx(FadeIn, {
        children: fadeProps => /*#__PURE__*/_jsx(SpinnerContainer, _objectSpread(_objectSpread({}, fadeProps), {}, {
          children: /*#__PURE__*/_jsx(AkSpinner, {
            appearance: appearance,
            delay: delay,
            size: size,
            testId: getSpinnerTestId(testId),
            interactionName: interactionName
          })
        }))
      })
    }), /*#__PURE__*/_jsx(ContentWrapper, {
      visible: !active,
      children: children
    })]
  });
};
export default SpinnerMask;